import type { EscalationsStateDTO } from "../data/escalationsApi";

/**
 * The workspace preview's escalation-contacts summary — written by the
 * escalations screen after every change (the teamAccess pattern) so the right
 * rail can render it without re-reading the lists.
 */
export const ESCALATIONS_PREVIEW_KEY = "escalationsAccess";

export interface EscalationsPreview {
  /** ORDERED — the order go-live pushes to the tenant, where it is displayed. */
  escalation: string[];
  /** How many people see the dashboard; the rail shows a count, not a roster. */
  dashboardCount: number;
}

export function toEscalationsPreview(state: EscalationsStateDTO): EscalationsPreview {
  return {
    escalation: state.escalation.map((contact) => contact.name),
    dashboardCount: state.dashboard.length,
  };
}
